var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangUsa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_19049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 34C30.4183 34 34 30.4183 34 26C34 21.5817 30.4183 18 26 18C21.5817 18 18 21.5817 18 26C18 30.4183 21.5817 34 26 34Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6519 25.9991H33.9997C33.9997 25.277 33.9034 24.5775 33.7241 23.9121H25.6519V25.9991Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6519 21.8252H32.8255C32.3358 21.0261 31.7096 20.3198 30.9795 19.7383H25.6519V21.8252Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 33.9989C27.8827 33.9989 29.6132 33.3481 30.9798 32.2598H21.02C22.3866 33.3481 24.1171 33.9989 25.9999 33.9989Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.174 30.1729H32.8256C33.2188 29.5314 33.5237 28.8301 33.7242 28.0859H18.2754C18.4759 28.8301 18.7808 29.5314 19.174 30.1729Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7057 19.2493H22.4348L21.7567 19.742L22.0157 20.5391L21.3376 20.0465L20.6595 20.5391L20.8832 19.8505C20.2862 20.3478 19.7629 20.9305 19.3316 21.5798H19.5652L19.1336 21.8933C19.0663 22.0055 19.0018 22.1195 18.94 22.2352L19.1461 22.8696L18.7616 22.5902C18.666 22.7927 18.5785 22.9998 18.4999 23.2112L18.727 23.9102H19.5652L18.8871 24.4028L19.1461 25.2L18.468 24.7073L18.0618 25.0025C18.0212 25.3293 18 25.6622 18 26H26C26 21.5817 26 21.0609 26 18C24.4196 18 22.9464 18.4584 21.7057 19.2493ZM22.0157 25.2L21.3376 24.7073L20.6595 25.2L20.9185 24.4028L20.2404 23.9102H21.0786L21.3376 23.113L21.5966 23.9102H22.4348L21.7567 24.4028L22.0157 25.2ZM21.7567 22.0724L22.0157 22.8696L21.3376 22.3769L20.6595 22.8696L20.9185 22.0724L20.2404 21.5798H21.0786L21.3376 20.7826L21.5966 21.5798H22.4348L21.7567 22.0724ZM24.8853 25.2L24.2072 24.7073L23.5291 25.2L23.7881 24.4028L23.11 23.9102H23.9482L24.2072 23.113L24.4662 23.9102H25.3043L24.6262 24.4028L24.8853 25.2ZM24.6262 22.0724L24.8853 22.8696L24.2072 22.3769L23.5291 22.8696L23.7881 22.0724L23.11 21.5798H23.9482L24.2072 20.7826L24.4662 21.5798H25.3043L24.6262 22.0724ZM24.6262 19.742L24.8853 20.5391L24.2072 20.0465L23.5291 20.5391L23.7881 19.742L23.11 19.2493H23.9482L24.2072 18.4522L24.4662 19.2493H25.3043L24.6262 19.742Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_19049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangUsa);
export default __webpack_public_path__ + "static/media/lang-USA.ebc41ed2997a9a4cfb1737646eb14875.svg";
export { ForwardRef as ReactComponent };